import { Stack, Text } from '@zorro/web/design-system';
import {
  CoveragePeriodFormFields,
  CoveragePeriodInputs,
} from '@zorro/web/shared-ui';
import { UseFormReturn } from 'react-hook-form';

type Props = {
  sectionNumber: number;
  employeeId: string;
  onboardingPeriodId: string;
  coveragePeriodForm: UseFormReturn<CoveragePeriodFormFields>;
};

export const EnrollmentCoveragePeriodSection = ({
  sectionNumber,
  employeeId,
  onboardingPeriodId,
  coveragePeriodForm,
}: Props) => {
  return (
    <Stack my="xl" ml="xs" gap="xxs">
      <Text w="100%" size="md" fw={600}>
        {sectionNumber}. Confirmed coverage period
      </Text>
      <Stack ml="md" gap="md">
        <Text size="sm" c="var(--color-text-default-secondary)">
          Verify the confirmed coverage period
        </Text>
        <CoveragePeriodInputs
          employeeId={employeeId}
          onboardingPeriodId={onboardingPeriodId}
          coveragePeriodForm={coveragePeriodForm}
        />
      </Stack>
    </Stack>
  );
};
